module.exports = __webpack_public_path__ + "img/192.d6aa3ab1.png";